/* ==========================================================================
   TNF Afterpay messaging 1.1.0                                   2026-09-25
   1.1.0 (Jack, 25 Sep 2026: Afterpay on the US store too): the currency,
   Afterpay's consumer locale and the merchant ID now come from each holder
   (snippets/tnf-afterpay-config.liquid decides: AUD on; USD only once
   Afterpay is live at the USD checkout). Standard product pages in a
   currency the store's Shopify-Afterpay snippet does not cover (USD) get the
   same element beneath their price, following the selected variant's price
   (window.TNF_AP_PRODUCT, written by layout/theme.liquid only then).
   Everything else is 1.0.0.
   Keeps Afterpay's official on-site message (<square-placement>, Afterpay's
   square-marketplace.js) on the amount the customer is looking at, wherever
   snippets/tnf-afterpay.liquid placed a holder:
     catalogue  the catalogue page's rendered price - tnf-cat publishes every
                price it draws as the 'tnf:price' event (after any promotion
                the page shows; null while no price is shown)
     creator    the creator's own quote, window.TNF.quote().payable, each time
                the creator redraws its total (#tnf-total); hidden while the
                design needs a quote from us
     cart /     Shopify's cart total (cart.total_price, from /cart.js) each
     mini-cart  time the cart page or the drawer changes
   The element, its merchant ID and its settings are the ones the store's
   existing Shopify-Afterpay snippet (v1.1.7, layout/theme.liquid) uses, so
   Afterpay's own service decides the wording and applies this store's limits
   (read 25 Sep 2026: A$0.00 to A$4,000.00). Nothing here divides by four.
   An amount change re-renders the message (Afterpay observes data-amount).
   Afterpay's element only re-renders on a CHANGE of data-amount, so a holder
   gets its element the first time there is an amount to show.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__tnfAfterpay) return;
  window.__tnfAfterpay = { version: '1.1.0' };

  var LIB = 'https://js.squarecdn.com/square-marketplace.js';
  /* identical to the store's Shopify-Afterpay snippet 1.1.7 settings: upper limit shown, lower limit hidden,
     shown outside the limits, bold amount, size sm, compact badge (Afterpay's colour badge), info icon */
  var SETTINGS = {
    'data-platform': 'shopify-snippet', 'data-show-upper-limit': 'true', 'data-show-lower-limit': 'false',
    'data-show-if-outside-limits': 'true', 'data-payment-amount-is-bold': 'true', 'data-size': 'sm',
    'data-logo-type': 'compact-badge'
  };

  function fmt(n) { return (Math.round(Number(n) * 100) / 100).toFixed(2); }
  function holders(ctx) { return document.querySelectorAll('[data-tnf-ap="' + ctx + '"]'); }

  /* Afterpay's library: the existing snippet loads it in AUD; load it here only if nothing else has */
  function ensureLib() {
    if ((window.customElements && window.customElements.get('square-placement')) ||
        document.querySelector('script[src*="square-marketplace.js"]')) return;
    var s = document.createElement('script'); s.src = LIB; s.async = true; document.head.appendChild(s);
  }

  function place(holder, amount) {
    var p = document.createElement('square-placement');
    p.setAttribute('data-mpid', holder.getAttribute('data-mpid'));
    p.setAttribute('data-currency', holder.getAttribute('data-currency'));
    p.setAttribute('data-consumer-locale', holder.getAttribute('data-locale') || (holder.getAttribute('data-currency') === 'USD' ? 'en_US' : 'en_AU'));
    p.setAttribute('data-page-type', holder.getAttribute('data-page-type') || 'product');
    for (var k in SETTINGS) p.setAttribute(k, SETTINGS[k]);
    if ((holder.getAttribute('data-page-type') || 'product') !== 'product') p.setAttribute('data-show-interest-free', 'false');
    p.setAttribute('data-amount', fmt(amount));
    holder.appendChild(p);
    return p;
  }

  /* show(ctx, amount): amount in the store currency, or null/0 to hide (no price on show) */
  function show(ctx, amount) {
    var ok = amount != null && isFinite(Number(amount)) && Number(amount) > 0;
    var list = holders(ctx);
    for (var i = 0; i < list.length; i++) {
      var h = list[i];
      if (!ok) { h.hidden = true; h.setAttribute('data-amount', ''); continue; }
      var p = h.querySelector('square-placement'), a = fmt(amount);
      if (!p) p = place(h, amount);
      else if (p.getAttribute('data-amount') !== a) p.setAttribute('data-amount', a);
      h.setAttribute('data-amount', a);
      h.hidden = false;
    }
    if (ok && list.length) ensureLib();
  }

  /* ---- catalogue: the page publishes every price it renders ---------------- */
  document.addEventListener('tnf:price', function (e) {
    var d = (e && e.detail) || {};
    if (d.source && d.source !== 'catalogue') return;
    show('catalogue', d.ok ? d.amount : null);
  });
  function catalogueInitial() { var d = window.__tnfCatPrice; if (d) show('catalogue', d.ok ? d.amount : null); }

  /* ---- creator: its public quote, read each time it redraws the total ------ */
  var creatorQueued = false;
  function creatorSync() {
    creatorQueued = false;
    var box = document.getElementById('tnf-total'); if (!box || !holders('creator').length) return;
    if (box.classList.contains('is-calculating')) return;          /* keep the last amount while it re-checks */
    var shown = box.querySelector('.tnf-total-amt');                /* the total card shows an amount */
    var q = window.TNF && typeof window.TNF.quote === 'function' ? window.TNF.quote() : null;
    show('creator', shown && q && q.payable != null ? Number(q.payable) : null);
  }
  function creatorWatch() {
    var box = document.getElementById('tnf-total'); if (!box || !holders('creator').length) return;
    new MutationObserver(function () { if (!creatorQueued) { creatorQueued = true; requestAnimationFrame(creatorSync); } })
      .observe(box, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    creatorSync();
  }

  /* ---- cart page and drawer: Shopify's own cart total --------------------- */
  var cartTimer = null, cartSeq = 0;
  function cartSync() {
    clearTimeout(cartTimer);
    cartTimer = setTimeout(function () {
      if (!holders('cart').length && !holders('mini-cart').length) return;
      var seq = ++cartSeq;
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          if (seq !== cartSeq) return;
          var a = c && c.item_count ? c.total_price / 100 : null;
          show('cart', a); show('mini-cart', a);
        }).catch(function () {});
    }, 300);
  }
  function cartWatch() {
    var targets = [document.querySelector('[data-cart-total]'), document.getElementById('halo-cart-sidebar')];
    targets.forEach(function (t) {
      if (!t) return;
      new MutationObserver(function (m) {
        for (var i = 0; i < m.length; i++) { var n = m[i].target; if (n && n.closest && n.closest('.tnf-ap')) continue; cartSync(); return; }
      }).observe(t, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-cart-total-value'] });
    });
    if (holders('cart').length || holders('mini-cart').length) ensureLib();
  }

  /* ---- 1.1.0: standard product pages in USD - the selected variant's price -- */
  function productWatch() {
    var P = window.TNF_AP_PRODUCT;
    if (!P || window.TNF_AP_OWNS_PRODUCT || holders('product').length) return;
    var price = document.querySelector('.productView-price[id^="product-price-"]');
    if (!price || !price.parentNode) return;
    var h = document.createElement('div');
    h.className = 'tnf-ap tnf-ap--product'; h.hidden = true;
    h.setAttribute('data-tnf-ap', 'product'); h.setAttribute('data-mpid', P.mpid); h.setAttribute('data-currency', P.currency);
    h.setAttribute('data-locale', P.locale); h.setAttribute('data-page-type', 'product');
    price.parentNode.insertBefore(h, price.nextSibling);
    var byId = {}; (P.variants || []).forEach(function (v) { byId[String(v.id)] = v.price; });
    function current() {
      var f = price.closest('form') || document.querySelector('form[action*="/cart/add"]');
      var inp = (f && f.querySelector('[name="id"]')) || document.querySelector('form[action*="/cart/add"] [name="id"]');
      var id = inp && inp.value ? String(inp.value) : String(P.selected || '');
      return byId[id] != null ? byId[id] / 100 : null;
    }
    var q = false;
    function sync() { q = false; show('product', current()); }
    function later() { if (!q) { q = true; setTimeout(sync, 60); } }
    document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]')) later(); }, true);
    new MutationObserver(later).observe(price, { childList: true, subtree: true, characterData: true });
    var f0 = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (f0) new MutationObserver(later).observe(f0, { attributes: true, attributeFilter: ['value'] });
    sync();
  }

  function init() { catalogueInitial(); creatorWatch(); cartWatch(); productWatch(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* the snippet normally loads Afterpay's library; if it did not (blocked, removed), load it once the page is up */
  window.addEventListener('load', function () { if (document.querySelector('.tnf-ap:not([hidden])')) ensureLib(); });
  window.__tnfAfterpay.show = show;
})();
